import React from 'react'
import { FailedPopup } from '../../common/Utils/Utils'

const GeneralButton = ({ onClick, disabled, title,disabledMessage, type="btn-master", icon }) => {


    return (
        disabled? 
                <button 
                    className={`btn px_btn ${type} px-4 rounded fw_500 font_12 w-100 disabled_tone`} 
                    // disabled={disabled}
                    onClick={() => !!disabledMessage && FailedPopup(disabledMessage)}>
                        {icon && icon}
                        {title}
                </button>
              :
                <button 
                    className={`btn px_btn ${type} px-4 rounded fw_500 font_12 w-100`} 
                    onClick={onClick}>
                        {icon && icon}
                        {title}
                </button>

    )
}

export default GeneralButton